export default __webpack_public_path__ + "static/media/person-avatar.4cd31248.png";